<nz-spin [nzSpinning]="loading$ | async">
  <form
    nz-form
    class="org-user-view-form form"
    nzLayout="horizontal"
    [formGroup]="organizationUserForm"
    (ngSubmit)="onSubmit()">
    <div class="form-grid">
      <nz-form-item>
        <nz-form-label nzFor="email" nzRequired>Username</nz-form-label>
        <nz-form-control [nzErrorTip]="emailErrorTpl">
          <input
            name="warningValid"
            type="text"
            nz-input
            id="email"
            formControlName="email"
            placeholder="Enter your user name" />
          <ng-template #emailErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')">
              Please enter your username.
            </ng-container>
            <ng-container
              *ngIf="control.hasError('email') || control.hasError('pattern')">
              Please enter a valid username.
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="firstName" nzRequired>First Name</nz-form-label>
        <nz-form-control [nzErrorTip]="firstNameErrorTpl">
          <input
            name="warningValid"
            type="text"
            nz-input
            id="firstName"
            formControlName="firstName"
            placeholder="Enter your first name" />
          <ng-template #firstNameErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')">
              Please enter your first name.
            </ng-container>
            <ng-container *ngIf="control.hasError('minlength')">
              First name must be at least 2 characters.
            </ng-container>
            <ng-container *ngIf="control.hasError('maxlength')">
              First name can not exceed 50 characters.
            </ng-container>
            <ng-container
              *ngIf="
                control.hasError('empty') &&
                !control.hasError('minlength') &&
                !control.hasError('maxlength')
              ">
              Please enter a valid first name.
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="lastName" nzRequired>Last Name</nz-form-label>
        <nz-form-control [nzErrorTip]="lastNameErrorTpl">
          <input
            name="warningValid"
            type="text"
            nz-input
            id="lastName"
            formControlName="lastName"
            placeholder="Enter your last name" />
          <ng-template #lastNameErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')">
              Please enter your last name.
            </ng-container>
            <ng-container *ngIf="control.hasError('minlength')">
              Last name must be at least 2 characters.
            </ng-container>
            <ng-container *ngIf="control.hasError('maxlength')">
              Last name can not exceed 50 characters.
            </ng-container>
            <ng-container
              *ngIf="
                control.hasError('empty') &&
                !control.hasError('minlength') &&
                !control.hasError('maxlength')
              ">
              Please enter a valid last name.
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="titleId" nzRequired>Title</nz-form-label>
        <nz-form-control nzErrorTip="Please select your title.">
          <nz-select
            nzSuffixIcon
            nzShowSearch
            nzAllowClear
            id="titleId"
            formControlName="titleId"
            nzPlaceHolder="Select a title"
            name="last">
            @for (title of titleList; track title) {
              <nz-option
                [nzLabel]="title.title"
                [nzValue]="title.id"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="roleIds" nzRequired>User Role</nz-form-label>
        <nz-form-control nzErrorTip="Please select your user roles.">
          <nz-select
            nzSuffixIcon
            nzShowSearch
            nzAllowClear
            nzMode="multiple"
            nzShowArrow="true"
            id="roleIds"
            nzPlaceHolder="Select a roles"
            formControlName="roleIds"
            name="roleIds">
            @for (role of roleList; track role) {
              <nz-option
                [nzLabel]="role.name"
                [nzValue]="role.id"
                [nzCustomContent]="true">
                <span>{{ role.name }}</span>
                <svg-icon
                  *ngIf="getRoleDescription(role.name)"
                  nz-tooltip
                  [nzTooltipTitle]="getRoleDescription(role.name)"
                  src="/assets/icon/icon-help.svg"
                  class="icon s-12 ml-6"
                  aria-label="Help">
                </svg-icon>
              </nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="statusId" nzRequired>Status</nz-form-label>
        <nz-form-control nzErrorTip="Please select your status.">
          <nz-select
            nzSuffixIcon
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select a status"
            formControlName="statusId"
            name="statusId">
            @for (status of statusList; track status) {
              <nz-option
                [nzLabel]="status.value | titlecase"
                [nzValue]="status.id"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div class="btn-wrapper-end mb-24">
      <button
        type="button"
        nz-button
        [nzType]="'primary'"
        class="btn"
        [nzLoading]="isLoading"
        [disabled]="!organizationUserForm.valid && isEditMode"
        (click)="isEditMode ? onSubmit() : setEditMode()">
        {{ isEditMode ? 'Save' : 'Edit' }}
      </button>
    </div>
  </form>
  <form
    nz-form
    class="org-user-view-form form"
    nzLayout="horizontal"
    [formGroup]="moveUserForm"
    (ngSubmit)="onMoveUser()">
    <h3 class="title s-24 fw-600">Move User</h3>
    <nz-divider></nz-divider>
    <div class="form-grid">
      <nz-form-item>
        <nz-form-label nzFor="userName">Parent Organization</nz-form-label>
        <nz-form-control nzErrorTip="Please input your Org name.">
          <input
            name="warningValid"
            type="text"
            nz-input
            id="userName"
            formControlName="currentOrganizationName"
            [disabled]="true"
            placeholder="Enter your org name" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="email" nzRequired>Move to</nz-form-label>
        <nz-form-control nzErrorTip="Please select your new organization.">
          <nz-select
            nzSuffixIcon
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select"
            formControlName="newOrganizationId"
            name="newOrganizationId"
            [nzLoading]="loading"
            (nzOnSearch)="onSearchOrganization($event)">
            @for (org of newOrgList; track org) {
              <nz-option [nzLabel]="org.value" [nzValue]="org.id"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="email" nzRequired>Title</nz-form-label>
        <nz-form-control nzErrorTip="Please select your title.">
          <nz-select
            nzSuffixIcon
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select"
            formControlName="titleId"
            name="titleId">
            @for (title of titleListByOrgChange; track title) {
              <nz-option
                [nzLabel]="title.title"
                [nzValue]="title?.id"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div class="btn-wrapper-end mb-24">
      <button
        type="submit"
        nz-button
        [nzType]="'primary'"
        [nzLoading]="isMoveUserLoading"
        class="btn"
        [disabled]="!moveUserForm.valid">
        Move User
      </button>
    </div>
  </form>
</nz-spin>
